<h2 mat-dialog-title>Import data</h2>

<mat-dialog-content>
  <p class="br-text-muted">
    Import records into the start node of {{ data.workflowLabel }}.
    CSV headers may use either the field name or internal key.
  </p>

  <div class="br-card br-mt-3">
    <div class="br-card-body">
      <div class="br-small br-text-muted">Expected columns</div>
      <div class="br-mt-1">
        <span *ngFor="let field of activeFields; let last = last">
          {{ field.label }}{{ field.isRequired ? ' *' : '' }}{{ last ? '' : ', ' }}
        </span>
      </div>
    </div>
  </div>

  <input #fileInput type="file" accept=".csv,text/csv" hidden
         (change)="selectFile($event)">
  <button type="button"
          class="br-btn br-btn--outline-secondary br-mt-3"
          [disabled]="reading"
          (click)="fileInput.click()">
    <br-icon>upload_file</br-icon>
    {{ reading ? 'Reading…' : 'Choose CSV' }}
  </button>

  <div *ngIf="fileName" class="br-mt-2">{{ fileName }}</div>
  <div *ngIf="rows.length" class="br-alert br-alert--success br-mt-3">
    {{ rows.length }} {{ rows.length === 1 ? 'record' : 'records' }} ready to import.
  </div>
  <div *ngIf="errors.length" class="br-alert br-alert--danger br-mt-3" role="alert">
    <div *ngFor="let error of errors | slice:0:5">{{ error }}</div>
    <div *ngIf="errors.length > 5">And {{ errors.length - 5 }} more.</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--outline-secondary" mat-dialog-close>
    Cancel
  </button>
  <button type="button"
          class="br-btn br-btn--primary"
          [disabled]="!rows.length || errors.length"
          (click)="import()">
    Import
  </button>
</mat-dialog-actions>
